export default "<div class=\"ws-app\">\n  <app-login *ngIf=\"showLoginLoader\" [showInput]=\"false\"></app-login>\n  <router-outlet></router-outlet>\n</div>\n";